import React from "react";
import { BrowserRouter, Redirect, Switch, Route } from "react-router-dom";
// public
import ForgotPassword from "../screens/auth/ForgotPassword";
import SignIn from "../screens/auth/SignIn";
import SignUp from "../screens/auth/SignUp";
// import ShopifySignIn from '../screens/auth/ShopifySignIn';
// import ShopifySignUp from '../screens/auth/ShopifySignUp';

// private
import Overview from "../screens/overview";

// Routes
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";

const Routes = () => (
  <BrowserRouter>
    <Switch>
      <PublicRoute path="/" exact component={SignIn} />
      <PublicRoute path="/signin" exact component={SignIn} />
      <PublicRoute path="/signup" exact component={SignUp} />
      <PublicRoute path="/forgot_password/new" exact component={ForgotPassword} />

      <PrivateRoute path="/overview" exact component={Overview} />

      <Redirect to="/" />
    </Switch>
  </BrowserRouter>
);

export default Routes;
